const statsData = [
  {
    value: 59,
    prefix: '',
    suffix: '%',
    label: 'Of renters do not expect to be returned their security deposit.',
  },
  {
    value: 71,
    prefix: '',
    suffix: '%',
    label: 'Of landlords don\'t provide reciepts of deductions during move-out',
  },
  {
    value: 41,
    prefix: '',
    suffix: '%',
    label: 'Of renters actively challenge move-out damage charges.',
  },
];

export default statsData;
